enum VolumeStatus {
    AUDIBLE = 'AUDIBLE',
    MUTED = 'MUTED',
    FORCE_MUTED = 'FORCE_MUTED'
}

export default VolumeStatus;